import React, { useMemo } from "react";
import DataTable from "../_Components/DataTable";
import _ from "lodash";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

function DataGrid({ data }) {

  const columns = useMemo(
    () => [
      {
        accessor: "id",
        Header: "#",
        minWidth: 50,
      },
      {
        accessor: "typeS",
        Header: "نوع",
        minWidth: 100,
      },
      {
        accessor: "text",
        Header: "متن",
        minWidth: 300,
      },
      {
        accessor: "dateTimeSend",
        Header: "زمان ارسال",
        minWidth: 100,
      },
      {
        accessor: "receivePhoneNumber",
        Header: "شماره گیرنده",
        minWidth: 100,
      },
      {
        Header: "وضعیت",
        minWidth: 100,
        align: "center",
        Cell: ({ row }) =>
          row.original.isSend === true ? (
            <div className="text-center text-success">ارسال شده</div>
          ) : (
            <div className="text-center text-danger">ارسال نشده</div>
          ),
      },
      // {
      //     accessor: "created",
      //     Header: '"زمان ایجاد"',
      //     minWidth: '100px',
      // },
      {
        Header: "عملیات",
        accessor: "",
        minWidth: 100,
        align: "center",
        Cell: ({ row }) => (
          <div className="text-center d-flex align-items-center justify-content-center">
            {/* مشاهده */}
            {/* <button
                            className="btn btn-light-info btn-sm mr-2 btn-icon"
                        >
                            <i className='far fa-eye text-small'></i>
                        </button> */}

            {/* ویرایش */}
            {/* <Link variant="success"
                            key={row.original.id}
                            to={{
                                pathname: "/smsInfo/1",
                                state: { id: row.original.id }
                            }}
                            className="btn btn-light-primary btn-sm mr-2 btn-icon"
                        >
                            <i className='fas fa-history text-small'></i>
                        </Link> */}
            {!_.isEmpty(row.original.description) && (
              <div className="text-center">
                <OverlayTrigger
                  placement="top"
                  overlay={<Tooltip id="tooltip-top">{row.original.description}</Tooltip>}
                >
                  <i className="fas fa-info-circle text-primary"></i>
                </OverlayTrigger>
              </div>
            )}
          </div>
        ),
      },
    ],
    [],
  );

  const config = {
    page_size: 10,
    length_menu: [10, 20, 50, 100],
    show_filter: false,
    show_pagination: true,
    pagination: "advance",
    button: {
      excel: false,
      print: false,
    },
    language: {
      length_menu: " _MENU_  رکورد در هر صفحه",
      filter: "جستجو ...",
      info: " _START_ - _END_ از _TOTAL_ رکورد",
      pagination: {
        first: "First",
        previous: <i className="fa fa-chevron-right"></i>,
        next: <i className="fa fa-chevron-left"></i>,
        last: "Last",
      },
    },
  };
  return (
    <div>
      {/* {(!_.isEmpty(location.state) && _.isNumber(location.state?.id)) ?
                <AddEditeModal />
                :
                <></>
            } */}
      <DataTable config={config} columns={columns} data={data} />
    </div>
  );
}

export default DataGrid;
